
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useState } from "react";
import useTranslation from "next-translate/useTranslation";
import NarrowPage from "../../components/NarrowPage";
import Alert from "../../components/Alert";
import styles from "./styles/SignIn.module.css";
import { useRouter } from "next/router";
import { setLoadingBar } from "../../ducks/siteData";
import { api } from "../../services/api";
export default function PasswordRecovery() {
    const [email, setEmail] = useState(null);
    const [passwordError, setPasswordError] = useState(null);
    const { t } = useTranslation("common");
    const { t: registerT } = useTranslation("auth");
    const router = useRouter();
    function requestNewPassword() {
        const locale = router.locale;
        setLoadingBar(true);
        api
            .post("/password/create", { email, locale })
            .then(() => {
            setPasswordError(null);
            router.push("/signIn/recoveryEmailSent");
            setLoadingBar(false);
        })
            .catch(() => {
            setPasswordError(true);
        })
            .then(() => {
            setLoadingBar(false);
        });
    }
    return (<NarrowPage title={registerT("Password recovery")}>
      <div className="flex flex-col justify-center w-full">
        {passwordError && <Alert>{registerT("Email not available")}</Alert>}
        <label className={styles.label}>{t("Email")}</label>
        <input className="border rounded" autoFocus type="text" onChange={(event) => setEmail(event.target.value)}/>

        <div className="mt-5">
          <button className={styles.signInButton} onClick={() => email && requestNewPassword()}>
            {t("Send")}
          </button>
        </div>
      </div>
    </NarrowPage>);
}

    async function __Next_Translate__getStaticProps__1967461e645__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/signIn/passwordRecovery',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1967461e645__ as getStaticProps }
  